import { Injectable } from "@angular/core";
import { DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {
  
  constructor(
    private powerSupplyService: DefaultService) {
  }

  public sendNotification(file: Blob, notificationBlob: Blob) {
    return this.powerSupplyService.sendNotification(file, notificationBlob)
      .pipe(map(result => result));
  }
}
